/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const mutations = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu

    TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
        state.isVerticalNavMenuActive = value;
    },
    TOGGLE_REDUCE_BUTTON (state, val) {
        state.reduceButton = val;
    },
    UPDATE_MAIN_LAYOUT_TYPE (state, val) {
        state.mainLayoutType = val;
    },
    UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
        state.verticalNavMenuItemsMin = val;
    },
    UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
        state.verticalNavMenuWidth = width;
    },

    /**
     * Open project priority edit modal
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_OPEN_PRIORITY_EDIT_MODAL: function (state, data) {
        state.priorityEditModal.open = data;
    },

    /**
     * Open est dates calculation modal
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_OPEN_EST_DATE_CALCULATION_MODAL: function (state, data) {
        state.priorityEditModal.open = data;
    },

    /**
     * Close project priority edit modal
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_CLOSE_PRIORITY_EDIT_MODAL: function (state, data) {
        state.priorityEditModal.open = data;
    },

    /**
     * Open Timeline for Action Required Priority modal
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_OPEN_ACTION_REQUIRED_TIMELINE_MODAL: function (state, data) {
        state.actionRequiredTimeLineModal.open = data;
    },

    /**
     * Close Timeline for Action Required Priority modal
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_CLOSE_ACTION_REQUIRED_TIMELINE_MODAL: function (state, data) {
        state.actionRequiredTimeLineModal.open = data;
    },

    /**
     * Set Project priority modal data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_PRIORITY_EDIT_MODAL_DATA: function (state, data) {
        state.priorityEditModal.data = data;
    },

    SET_PRIORITY_OPTIONS: function (state, data) {
        state.priorityOptions = data;
    },

    // VxAutoSuggest

    UPDATE_STARRED_PAGE (state, payload) {

        // find item index in search list state
        const index = state.navbarSearchAndPinList['pages'].data.findIndex((item) => item.url === payload.url);

        // update the main list
        state.navbarSearchAndPinList['pages'].data[index].is_bookmarked = payload.val;

        // if val is true add it to starred else remove
        if (payload.val) {
            state.starredPages.push(state.navbarSearchAndPinList['pages'].data[index]);
        } else {
            // find item index from starred pages
            const index = state.starredPages.findIndex((item) => item.url === payload.url);

            // remove item using index
            state.starredPages.splice(index, 1);
        }
    },

    // Navbar-Vertical

    ARRANGE_STARRED_PAGES_LIMITED (state, list) {
        const starredPagesMore = state.starredPages.slice(10);
        state.starredPages = list.concat(starredPagesMore);
    },
    ARRANGE_STARRED_PAGES_MORE (state, list) {
        let downToUp = false;
        let lastItemInStarredLimited = state.starredPages[10];
        const starredPagesLimited = state.starredPages.slice(0, 10);
        state.starredPages = starredPagesLimited.concat(list);

        state.starredPages.slice(0, 10).map((i) => {
            if (list.indexOf(i) > -1) {
                downToUp = true;
            }
        });

        if (!downToUp) {
            state.starredPages.splice(10, 0, lastItemInStarredLimited);
        }
    },

    // ////////////////////////////////////////////
    // UI
    // ////////////////////////////////////////////

    TOGGLE_CONTENT_OVERLAY (state, val) {
        state.bodyOverlay = val;
    },
    UPDATE_PRIMARY_COLOR (state, val) {
        state.themePrimaryColor = val;
    },
    UPDATE_THEME (state, val) {
        state.theme = val;
    },
    UPDATE_WINDOW_WIDTH (state, width) {
        state.windowWidth = width;
    },
    UPDATE_WINDOW_SCROLL_Y (state, val) {
        state.scrollY = val;
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    // Updates user info in state and localstorage
    UPDATE_USER_INFO (state, payload) {
        // Get Data localStorage
        let userInfo = JSON.parse(localStorage.getItem('userInfo')) || state.AppActiveUser;

        if (userInfo && process.env.MIX_GOOGLE_TAG_MANAGER_ID) {
            // eslint-disable-next-line no-undef
            gtag('config', process.env.MIX_GOOGLE_TAG_MANAGER_ID, {
                'user_id': userInfo.id,
            });
        }

        for (const property of Object.keys(payload)) {
            if (payload[property] != null) {
                // If some of user property is null - user default property defined in state.AppActiveUser
                state.AppActiveUser[property] = payload[property];

                // Update key in localStorage
                userInfo[property] = payload[property];
            }
        }

        // Store data in localStorage
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
    },
    UPDATE_IMPERSONATOR_INFO (state, payload) {
        // Get Data localStorage
        let userInfo = JSON.parse(localStorage.getItem('impersonator')) || state.impersonator;

        if (userInfo && process.env.MIX_GOOGLE_TAG_MANAGER_ID) {
            // eslint-disable-next-line no-undef
            gtag('config', process.env.MIX_GOOGLE_TAG_MANAGER_ID, {
                'user_id': userInfo.id,
            });
        }
        if (payload !== null) {
            for (const property of Object.keys(payload)) {
                if (payload[property] != null) {
                    // If some of user property is null - user default property defined in state.AppActiveUser
                    state.impersonator[property] = payload[property];

                    // Update key in localStorage
                    userInfo[property] = payload[property];
                }
            }
        }
        // Store data in localStorage
        localStorage.setItem('impersonator', JSON.stringify(userInfo));
    },
    UPDATE_USER_ACCESS (state, payload) {
        state.accessRules = payload;

    },
    // Updates user info in state and localstorage
    UPDATE_APP_INFO (state, payload) {
        // Get Data localStorage
        let appInfo = JSON.parse(localStorage.getItem('appInfo')) || state.AppInfo;

        for (const property of Object.keys(payload)) {

            if (payload[property] != null) {
                // If some of user property is null - user default property defined in state.AppActiveUser
                state.AppInfo[property] = payload[property];

                // Update key in localStorage
                appInfo[property] = payload[property];
            }
        }

        // Store data in localStorage
        localStorage.setItem('appInfo', JSON.stringify(appInfo));
    },
};

export default mutations;

